/**
 * QueueHistorySummary - Grid of queue history counters (completed, no-shows, expired, cancelled)
 */

import { useTranslation } from 'react-i18next';
import { User } from '@/types';

interface QueueHistorySummaryProps {
  queueHistory: User['queueHistory'];
}

export default function QueueHistorySummary({ queueHistory }: QueueHistorySummaryProps) {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
      <div className="bg-surface border border-hairline rounded-xl p-4 border-l-2 border-l-success">
        <p className="text-sm text-ink-muted mb-1">{t('profilePage.completed')}</p>
        <p className="text-3xl font-semibold text-ink tabular-nums">{queueHistory.totalCompleted}</p>
      </div>
      <div className="bg-surface border border-hairline rounded-xl p-4 border-l-2 border-l-danger">
        <p className="text-sm text-ink-muted mb-1">{t('profilePage.noShows')}</p>
        <p className="text-3xl font-semibold text-ink tabular-nums">{queueHistory.totalNoShows}</p>
      </div>
      <div className="bg-surface border border-hairline rounded-xl p-4 border-l-2 border-l-warning">
        <p className="text-sm text-ink-muted mb-1">{t('profilePage.expired')}</p>
        <p className="text-3xl font-semibold text-ink tabular-nums">{queueHistory.totalExpired}</p>
      </div>
      <div className="bg-surface border border-hairline rounded-xl p-4 border-l-2 border-l-hairline-strong">
        <p className="text-sm text-ink-muted mb-1">{t('profilePage.cancelled')}</p>
        <p className="text-3xl font-semibold text-ink tabular-nums">{queueHistory.totalCancelled}</p>
      </div>
    </div>
  );
}
